module.exports = __webpack_public_path__ + "img/header-weddingRingsMokumeGane.f16dcc2.webp";